import { render, staticRenderFns } from "./CaseSearchDisplay.vue?vue&type=template&id=4ce5ceb4&scoped=true&"
import script from "./CaseSearchDisplay.vue?vue&type=script&setup=true&lang=js&"
export * from "./CaseSearchDisplay.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5ceb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemContent,VListItemTitle})
